// Icon mapping helper for template icons (backend returns icon name).
import {
  PartyPopper,
  GraduationCap,
  Church,
  Trophy,
  HeartHandshake,
  Sparkles,
  CalendarCheck,
  ClipboardList,
  ListChecks,
  Gift,
  HandCoins,
  Ticket,
  Wallet,
  ShoppingBag,
  FileSignature,
  Cake,
  Crown,
  Heart,
  Baby,
  Star,
  UtensilsCrossed,
  BookOpen,
  Stethoscope,
  Users,
  DollarSign,
} from "lucide-react";

const MAP = {
  "party-popper": PartyPopper,
  "graduation-cap": GraduationCap,
  "church": Church,
  "trophy": Trophy,
  "heart-handshake": HeartHandshake,
  "sparkles": Sparkles,
  "calendar-check": CalendarCheck,
  "clipboard-list": ClipboardList,
  "list-checks": ListChecks,
  "gift": Gift,
  "hand-coins": HandCoins,
  "ticket": Ticket,
  "wallet": Wallet,
  "shopping-bag": ShoppingBag,
  "file-signature": FileSignature,
  "cake": Cake,
  "crown": Crown,
  "heart": Heart,
  "baby": Baby,
  "star": Star,
  "utensils-crossed": UtensilsCrossed,
  "book-open": BookOpen,
  "stethoscope": Stethoscope,
  "users": Users,
  "dollar-sign": DollarSign,
};

export function TemplateIcon({ name, size = 20, strokeWidth = 1.5, className = "" }) {
  const Icon = MAP[name] || Sparkles;
  return <Icon size={size} strokeWidth={strokeWidth} className={className} />;
}

export const EVENT_TYPE_LABELS = {
  potluck: "Hoja de inscripción",
  calendar: "Reserva de citas",
  form: "Formulario",
  gift: "Regalo grupal",
  fundraiser: "Donaciones",
  tickets: "Boletos",
  dues: "Cuotas",
  store: "Tienda",
  waiver: "Consentimiento",
};

export function formatMoney(amount, currency = "MXN") {
  try {
    return new Intl.NumberFormat("es-MX", {
      style: "currency",
      currency,
      maximumFractionDigits: 2,
    }).format(Number(amount || 0));
  } catch {
    return `$${Number(amount || 0).toFixed(2)} ${currency}`;
  }
}
